import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useNotification } from '../../../../../../../hooks'
import { patchMockApplicantMatchingValue } from '../../../../../../RentalPortalApplicant'
import { useApplicantProfileContext } from '../../../../RentalPortalApplicantProfile.hooks'

import {
  getMatchEditValue,
  getMatchPayloadValue,
} from './useApplicantFitCheckValueEdit.utils'

export function useApplicantFitCheckValueEdit() {
  const { t } = useTranslation()

  const { handleAddErrorNotification } = useNotification()

  const { applicantId, handleEntityReload } = useApplicantProfileContext()

  const [editingField, setEditingField] = useState(null)
  const [editValue, setEditValue] = useState(null)
  const [isSaving, setSaving] = useState(false)

  function handleStartEdit(criterion) {
    setEditValue(getMatchEditValue(criterion))
    setEditingField(criterion.applicant_field)
  }

  function handleCancelEdit() {
    setEditingField(null)
    setEditValue(null)
  }

  async function handleSaveEdit(criterion) {
    setSaving(true)

    try {
      await patchMockApplicantMatchingValue({
        applicantId,
        payload: {
          [criterion.applicant_field]: getMatchPayloadValue({
            criterion,
            value: editValue,
          }),
        },
      })

      await handleEntityReload()

      handleCancelEdit()
    } catch {
      handleAddErrorNotification({
        textButtonValue: t('RentalPortal.ListingRetryBtnKey'),
        title: t('RentalPortal.MatchEditorErrorKey'),
        onClickTextButton: () => handleSaveEdit(criterion),
      })
    } finally {
      setSaving(false)
    }
  }

  return {
    editingField,
    editValue,
    handleCancelEdit,
    handleChangeEditValue: setEditValue,
    handleSaveEdit,
    handleStartEdit,
    isSaving,
  }
}
